// extracted by mini-css-extract-plugin
module.exports = {"carousel":"looping-carousel_carousel__hWVnl","carouselSlide":"looping-carousel_carouselSlide__EJn26"};